// extracted by mini-css-extract-plugin
module.exports = {"main-component":"select_main-component__2t-EJ"};